;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#share_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.017.23a.9.9 0 0 0-.925-.072l-16.9 8.506a.9.9 0 0 0 .163 1.673l6.933 1.893.035 5.384a.9.9 0 0 0 1.18.848.9.9 0 0 0 .447-.328l2.078-2.88 3.565 3.24a.9.9 0 0 0 .908.18.9.9 0 0 0 .582-.72L19.386 1.08a.9.9 0 0 0-.369-.85m-3.854 3.417-6.222 6.895-4.847-1.32zm.378 12.36-5.007-4.546 6.624-7.341z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "share_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v19H0z"
  })))));
};
export default SvgShare;